<script lang="ts">
  import type { ShellController } from './shell-controller.svelte';

  const { shell }: { shell: ShellController } = $props();

  let username = $state('');
  let email = $state('');
  let password = $state('');
  let confirmPassword = $state('');
  let confirmError = $state('');

  function onsubmit(event: SubmitEvent): void {
    event.preventDefault();
    if (password !== confirmPassword) {
      confirmError = 'Passwords do not match.';
      return;
    }
    confirmError = '';
    void shell.register({ username, email, password }).then(() => {
      password = '';
      confirmPassword = '';
    });
  }
</script>

<div class="wis-panel wis-panel--sub">
  <form id="register-form" {onsubmit} autocomplete="off">
    <span class="wis-error register__error" role="alert">
      {confirmError || shell.registerError}
    </span>
    <!-- 17: the server's storage ceiling (varchar(35) latin1, 2 bytes/char) — see UsernamePolicy. -->
    <input
      id="register-username"
      type="text"
      placeholder="Username"
      maxlength="17"
      required
      bind:value={username}
    />
    <input
      id="register-email"
      type="email"
      placeholder="email"
      maxlength="35"
      autocomplete="email"
      required
      bind:value={email}
    />
    <input
      id="register-password"
      type="password"
      placeholder="Password"
      maxlength="35"
      autocomplete="new-password"
      required
      bind:value={password}
    />
    <input
      id="register-confirm-password"
      type="password"
      placeholder="Confirm Password"
      maxlength="35"
      autocomplete="new-password"
      required
      bind:value={confirmPassword}
    />
    <button class="wis-btn register__submit" type="submit" disabled={shell.busy}>Register</button>
  </form>

  <button
    class="wis-btn register__back"
    type="button"
    onclick={() => {
      shell.navigate('pregame');
    }}>Back</button
  >
</div>

<style>
  .register__error {
    position: absolute;
    top: 138px;
    left: 25px;
    width: 250px;
  }

  #register-username,
  #register-email,
  #register-password,
  #register-confirm-password {
    position: absolute;
    left: 35px;
  }

  #register-username {
    top: 171px;
  }

  #register-email {
    top: 220px;
  }

  #register-password {
    top: 269px;
  }

  #register-confirm-password {
    top: 318px;
  }

  .register__submit {
    position: absolute;
    top: 367px;
    left: 68px;
    width: 164px;
    height: 34px;
    padding: 0;
  }

  .register__back {
    position: absolute;
    top: 420px;
    left: 91px;
    width: 117px;
    height: 34px;
    padding: 0;
  }
</style>
